export default "__VITE_ASSET__Bu85Q9mT__"